<div class="container-fluid">

    <div class="card-body container-body p-2">
        <div class="col-md-12 row m-0 p-0">
            <div class="col-md m-0 p-0">
                <div class="title-header">
                    <h5 class="m-0 p-0">Instore - Bulk Upload</h5>
                </div>
            </div>
            <div class="col-md m-0 p-0">
                <div class="d-flex justify-content-end detail-buttons p-0">
                    <div class="type-2 p-2">
                        <input #file type="file" accept="image/*" (change)="onFileChange($event)" style="display: none;" multiple="false" accept=".xlsx, .xls, .csv">
                        <div class="text-center">
                            <a class="btn btn-1" (click)="file.click()">
                                <span class="txt">Browse</span>
                                <span class="round"><i class="fa fa-file-excel-o fa-lg"></i></span>
                            </a>
                        </div>
                    </div>
                    <div class="type-3 p-2" *ngIf="_instoreLists && _instoreLists.length>0">
                        <div class="text-center">
                            <a class="btn btn-1" (click)="submitButtonClicked(success)">
                                <span class="txt">{{nModule ? submitText() : ""}}</span>
                                <span class="round" *ngIf="nModule != 2"><i class="fa fa-check" aria-hidden="true"></i></span>
                                <span class="round" *ngIf="nModule == 2"><i class="fa fa-upload fa-lg"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="upload">
            <div class="table-responsive box-table p-1">
                <table class="table table-borderless m-0 p-0">
                    <thead class="">
                        <tr class="justify-content-center ">

                            <th class="text-center">
                                <p class="m-0">S.NO</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">REGION</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">SHOWROOM</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">FLOOR</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">LOCATION</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">TYPE</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">CREATIVE</p>
                            </th>
                            <th class="" mat-sort-header="">
                                <p class="m-0">PARTICULARS</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">SIZE</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">INSTORE NAME</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">VENDOR</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">IMAGE</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">INSTALLATION DATE</p>
                            </th>
                            <th class="text-center" mat-sort-header="">
                                <p class="m-0">EXPIRY DATE</p>
                            </th>
                        </tr>
                    </thead>

                    <tbody class="">
                        <tr class="" *ngFor="let data of _instoreLists | customerEmailFilter: email | slice: (page-1) * pageSize : page * pageSize;let i=index">
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data) }">
                                <p class="m-0 p-0">{{i + 1 + (page - 1) * pageSize}}</p>
                            </td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data), 'showred': data.region_id <= 0 }">
                                <p class="m-0 p-0">{{data.region}}</p>
                            </td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data), 'showred': data.showroom_id <= 0 }">
                                <p class="m-0">{{data.showroom}}</p>
                            </td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data), 'showred': data.floor_id <= 0 }">
                                <p class="m-0">{{data.floor}}</p>
                            </td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data), 'showred': data.location_id <= 0 }">
                                <p class="m-0">{{data.location}}</p>
                            </td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data), 'showred': data.asset_type_id <= 0 }">
                                <p class="m-0">{{data.asset_type}}</p>
                            </td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data), 'showred': data.creative_id <= 0 }">
                                <p class="m-0">{{data.creative}}</p>
                            </td>
                            <td class="" [ngClass]="{ 'showgreen': checkForGreen(data) }">
                                <p class="m-0">{{data.particulars}}</p>
                            </td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data) }">
                                W {{splitNumber(data.size_w)}} x H {{splitNumber(data.size_h)}}
                            </td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data), 'showred': data.id <= 0 }">
                                <p class="m-0">{{data.name}}</p>
                            </td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data), 'showred': data.vendor_id <= 0 }">
                                <p class="m-0">{{data.vendor}}</p>
                            </td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data) }">{{data.image}}</td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data) }">{{data.install_date| date: 'dd/MM/yyyy' }}</td>
                            <td class="text-center" [ngClass]="{ 'showgreen': checkForGreen(data) }">{{data.expiry_date| date: 'dd/MM/yyyy' }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="text-center p-5" *ngIf="_instoreLists && _instoreLists.length === 0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                  <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                </svg>
                    <p class="m-0 no-record"> No Record Found </p>
                </div>
            </div>
            <div class="mt-3 sl-pagination text-center justify-content-center">
                <ngb-pagination [(page)]="page" [pageSize]="pageSize" *ngIf="_instoreLists.length > 10" [maxSize]="5" [collectionSize]="_instoreLists.length" aria-label="Default pagination" class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
            </div>

        </div>
    </div>
</div>
<ng-template #success let-modal class="mp-0">
    <div class="p-2">
        <div class="modal-header justify-content-center">
            <div class="icon-box mx-auto">
                <i class="fa fa-check fa-5x  text-white" aria-hidden="true"></i>
            </div>
        </div>
        <div class="modal-body text-center">
            <h5>Instore has been added successfully.</h5>
            <button class="btn btn-okay" (click)="modal.dismiss('Cross click')"><span>Ok</span></button>
        </div>
    </div>
</ng-template>